module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"work":"Работают","error":"Ошибка","inactive":"Неактивны"},"en":{"work":"Work","error":"Error","inactive":"Inactive"}}')
  delete Component.options._Ctor
}
